import { LocalCache, StorageKey } from "../../../../../cache/LocalCache"

// Keyed by effective user: order-on-behalf changes who the timeline is opened for.
export type PerUserRecord<T> = Record<string, T>

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === "object" && value !== null && !Array.isArray(value)
}

/** Entries `parseValue` rejects are dropped, so a stale shape never reaches the caller. */
export function readPerUserStorage<T>(
    key: StorageKey,
    parseValue: (value: unknown) => T | undefined,
): PerUserRecord<T> {
    try {
        const raw = LocalCache().get(key)
        if (!raw) return {}

        const parsed: unknown = JSON.parse(raw)
        if (!isRecord(parsed)) return {}

        return Object.entries(parsed).reduce<PerUserRecord<T>>((acc, [userId, value]) => {
            const parsedValue = parseValue(value)
            if (parsedValue !== undefined) acc[userId] = parsedValue
            return acc
        }, {})
    } catch {
        // Unreadable storage (truncated entry, private mode) reads as "nothing saved".
        return {}
    }
}

export function writePerUserStorage<T>(key: StorageKey, stored: PerUserRecord<T>): void {
    try {
        LocalCache().set(key, JSON.stringify(stored))
    } catch {
        // A full or read-only storage costs the preference, never the booking flow.
    }
}
